import BaseAPI from "../api";

const path: string = "/visa-request-front";

export class VisaRequestFrontApi extends BaseAPI {
  static list(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static sent_coordinator(id: number): Promise<any> {
    return this.api.patch(`${path}/${id}/sent_coordinator`);
  }
 
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static course_annual(query?: any): Promise<any> {
    return this.api.get(`${path}/course_annual`,{
      params: { ...query },
    });
  }
  static course_annual_id(id: any,query?: any): Promise<any> {
    return this.api.get(`${path}/course_annual/${id}`,{
      params: { ...query },
    });
  }

  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static deleteFile(id: any, id_visa_form_file: any): Promise<any> {
    return this.api.delete(`${path}/${id}/file/${id_visa_form_file}`);
  }
  static file(id: any, body: any): Promise<any> {
    return this.api.post(`${path}/${id}/file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static paymentFile(id: any, body: any): Promise<any> {
    return this.api.post(`${path}/${id}/payment/file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
